"use strict";
/* eslint-disable @typescript-eslint/no-redeclare */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IX_TITLES = exports.IX_STRUCTS = exports.TokenInstructionType = exports.TransferChecked = exports.Transfer = exports.TokenAmountUi = void 0;
const superstruct_1 = require("superstruct");
const pubkey_1 = require("../../validators/pubkey");
exports.TokenAmountUi = (0, superstruct_1.type)({
    amount: (0, superstruct_1.string)(),
    decimals: (0, superstruct_1.number)(),
    uiAmountString: (0, superstruct_1.string)(),
});
const InitializeMint = (0, superstruct_1.type)({
    mint: pubkey_1.PublicKeyFromString,
    decimals: (0, superstruct_1.number)(),
    mintAuthority: pubkey_1.PublicKeyFromString,
    rentSysvar: pubkey_1.PublicKeyFromString,
    freezeAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
});
const InitializeAccount = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    mint: pubkey_1.PublicKeyFromString,
    owner: pubkey_1.PublicKeyFromString,
    rentSysvar: pubkey_1.PublicKeyFromString,
});
const InitializeMultisig = (0, superstruct_1.type)({
    multisig: pubkey_1.PublicKeyFromString,
    rentSysvar: pubkey_1.PublicKeyFromString,
    signers: (0, superstruct_1.array)(pubkey_1.PublicKeyFromString),
    m: (0, superstruct_1.number)(),
});
exports.Transfer = (0, superstruct_1.type)({
    source: pubkey_1.PublicKeyFromString,
    destination: pubkey_1.PublicKeyFromString,
    amount: (0, superstruct_1.union)([(0, superstruct_1.string)(), (0, superstruct_1.number)()]),
    authority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
});
const Approve = (0, superstruct_1.type)({
    source: pubkey_1.PublicKeyFromString,
    delegate: pubkey_1.PublicKeyFromString,
    amount: (0, superstruct_1.union)([(0, superstruct_1.string)(), (0, superstruct_1.number)()]),
    owner: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigOwner: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
});
const Revoke = (0, superstruct_1.type)({
    source: pubkey_1.PublicKeyFromString,
    owner: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigOwner: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
});
const AuthorityType = (0, superstruct_1.enums)(["mintTokens", "freezeAccount", "accountOwner", "closeAccount"]);
const SetAuthority = (0, superstruct_1.type)({
    mint: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    account: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    authorityType: AuthorityType,
    newAuthority: (0, superstruct_1.nullable)(pubkey_1.PublicKeyFromString),
    authority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
});
const MintTo = (0, superstruct_1.type)({
    mint: pubkey_1.PublicKeyFromString,
    account: pubkey_1.PublicKeyFromString,
    amount: (0, superstruct_1.union)([(0, superstruct_1.string)(), (0, superstruct_1.number)()]),
    mintAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigMintAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
});
const Burn = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    mint: pubkey_1.PublicKeyFromString,
    amount: (0, superstruct_1.union)([(0, superstruct_1.string)(), (0, superstruct_1.number)()]),
    authority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
});
const CloseAccount = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    destination: pubkey_1.PublicKeyFromString,
    owner: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigOwner: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
});
const FreezeAccount = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    mint: pubkey_1.PublicKeyFromString,
    freezeAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigFreezeAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
});
const ThawAccount = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    mint: pubkey_1.PublicKeyFromString,
    freezeAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigFreezeAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
});
exports.TransferChecked = (0, superstruct_1.type)({
    source: pubkey_1.PublicKeyFromString,
    mint: pubkey_1.PublicKeyFromString,
    destination: pubkey_1.PublicKeyFromString,
    authority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
    tokenAmount: exports.TokenAmountUi,
});
const ApproveChecked = (0, superstruct_1.type)({
    source: pubkey_1.PublicKeyFromString,
    mint: pubkey_1.PublicKeyFromString,
    delegate: pubkey_1.PublicKeyFromString,
    owner: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigOwner: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
    tokenAmount: exports.TokenAmountUi,
});
const MintToChecked = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    mint: pubkey_1.PublicKeyFromString,
    mintAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigMintAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
    tokenAmount: exports.TokenAmountUi,
});
const BurnChecked = (0, superstruct_1.type)({
    account: pubkey_1.PublicKeyFromString,
    mint: pubkey_1.PublicKeyFromString,
    authority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    multisigAuthority: (0, superstruct_1.optional)(pubkey_1.PublicKeyFromString),
    signers: (0, superstruct_1.optional)((0, superstruct_1.array)(pubkey_1.PublicKeyFromString)),
    tokenAmount: exports.TokenAmountUi,
});
exports.TokenInstructionType = (0, superstruct_1.enums)([
    "initializeMint",
    "initializeAccount",
    "initializeMultisig",
    "transfer",
    "approve",
    "revoke",
    "setAuthority",
    "mintTo",
    "burn",
    "closeAccount",
    "freezeAccount",
    "thawAccount",
    "transfer2",
    "approve2",
    "mintTo2",
    "burn2",
    "transferChecked",
    "approveChecked",
    "mintToChecked",
    "burnChecked",
]);
exports.IX_STRUCTS = {
    initializeMint: InitializeMint,
    initializeAccount: InitializeAccount,
    initializeMultisig: InitializeMultisig,
    transfer: exports.Transfer,
    approve: Approve,
    revoke: Revoke,
    setAuthority: SetAuthority,
    mintTo: MintTo,
    burn: Burn,
    closeAccount: CloseAccount,
    freezeAccount: FreezeAccount,
    thawAccount: ThawAccount,
    transfer2: exports.TransferChecked,
    approve2: ApproveChecked,
    mintTo2: MintToChecked,
    burn2: BurnChecked,
    transferChecked: exports.TransferChecked,
    approveChecked: ApproveChecked,
    mintToChecked: MintToChecked,
    burnChecked: BurnChecked,
};
exports.IX_TITLES = {
    initializeMint: "Initialize Mint",
    initializeAccount: "Initialize Account",
    initializeMultisig: "Initialize Multisig",
    transfer: "Transfer",
    approve: "Approve",
    revoke: "Revoke",
    setAuthority: "Set Authority",
    mintTo: "Mint To",
    burn: "Burn",
    closeAccount: "Close Account",
    freezeAccount: "Freeze Account",
    thawAccount: "Thaw Account",
    transfer2: "Transfer (Checked)",
    approve2: "Approve (Checked)",
    mintTo2: "Mint To (Checked)",
    burn2: "Burn (Checked)",
    transferChecked: "Transfer (Checked)",
    approveChecked: "Approve (Checked)",
    mintToChecked: "Mint To (Checked)",
    burnChecked: "Burn (Checked)",
};
//# sourceMappingURL=types.js.map